<app-dialog *ngIf="history"
  [showHeader]="true"
  header="Transaction date/time history"
  saveBtnText="Create"
  [minWidth]="560"
  [hasControls]="false"
  [show]="true"
  [hideHeaderUnderline]="true">
  <table class="table-primary">
    <thead>
    <tr>
      <th class="text-left" scope="col">Recorded</th>
      <th></th>
      <th></th>
      <th class="text-center arrow"></th>
      <th class="text-right" scope="col">Changes</th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let record of history">
      <th scope="row w-4/12">
        <div class="heading">
          {{record.createDate | formattedDate: 'MM d a, HH:mm' }}
        </div>
        <div class="secondary">
          {{record.userFirstName}} {{record.userLastName[0]}}
        </div>
      </th>
      <td></td>
      <td class="text-right !pr-2">{{record.transactionDateOld | formattedDate: 'MM d a, HH:mm'}}</td>
      <td class="text-center arrow">
        <img class="inline" src="assets/icons/icon-arrow-right.svg" alt="icon-arrow-right"/>
      </td>
      <td class="text-left !pl-2">{{record.transactionDateNew | formattedDate: 'MM d a, HH:mm'}}</td>
    </tr>
    </tbody>
  </table>

  <app-button class="float-right mt-6"
    text="Close"
    [minWidth]="72"
    (clicked)="closed.emit()"
  ></app-button>

</app-dialog>